import React, { Fragment, useState } from 'react'
import { Dialog } from '@material-ui/core'
import { ShowMoreLink, TruncateWrapper } from './styles'
import MarkdownRenderer from '../../../common/components/markdown'
import { stripMarkdown, stripLineBreaks } from '../../../common/helpers'
import { StyledSpan } from '../../../theme/Global'

const ExpandableTruncatedText = ({ text, truncateNumber, modal, isNotMarkdown }) => {
  const [openModal, setOpen] = useState(false)
  const [isTruncated, setIsTruncated] = useState(text.length > truncateNumber)
  const handleClick = () => (!modal ? setIsTruncated(!isTruncated) : setOpen(!openModal))
  const cleanText = stripLineBreaks(stripMarkdown(text))

  return (
    <Fragment>
      <Fragment>
        {isNotMarkdown ? (
          <StyledSpan data-testid="truncated-text">
            {isTruncated ? `${text.substring(0, truncateNumber)}...` : `${text}`}
          </StyledSpan>
        ) : (
          <TruncateWrapper truncate={isTruncated}>
            <MarkdownRenderer className="text">
              {text}
            </MarkdownRenderer>
          </TruncateWrapper>
        )}
        {(cleanText.length > truncateNumber)
          ? (
            <ShowMoreLink onClick={handleClick} data-testid="show-more-link">
              {` (show ${isTruncated ? 'more' : 'less'})`}
            </ShowMoreLink>
          )
          : null}
      </Fragment>
      {modal
        ? (
          <Dialog
            data-testid="truncated-text-modal"
            open={openModal}
            onClose={() => setOpen(false)}
            maxWidth="md"
          >
            {modal}
          </Dialog>
        )
        : null}
    </Fragment>
  )
}

export default ExpandableTruncatedText
